<style lang="less" scoped src="@/assets/less/manage-space/base.less">
.calendar-container {
    display: flex;
    // min-height: 100%;
    max-height: 100vh;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
}

.calendar {
    max-height: 50vh;
    height: 50vh;
    margin: 0 10px;
    padding: 10px;
    border: 1px solid transparent;
    border-radius: 1.125rem !important;
    background-color: #fff;

    .fc .fc-toolbar.fc-header-toolbar {
        border-top-left-radius: 1.125rem !important;
        border-top-right-radius: 1.125rem !important;
    }
}

.resources-list {
    max-height: 200px !important;
    height: 200px !important;
    overflow-y: auto;
}

.co {
    .btn .b-icon.bi {
        margin: 0 !important;
    }
}

.fc .fc-bg-event {
    top: 0.25em !important;
    bottom: 0.25em !important;
}

.fc-media-screen .fc-timegrid-event {
    top: 0.25em !important;
    bottom: 0.25em !important;
    line-height: 14px;
    font-size: 12px;
    font-style: normal;
    padding: 4px;
}

.fc-direction-ltr .fc-timegrid-col-events {
    margin-left: 0.25em !important;
    margin-right: 0.25em !important;
}

.fc .fc-timegrid-col-bg {
    margin-left: 0.25em !important;
    margin-right: 0.25em !important;
}

.fc-theme-standard td,
.fc-theme-standard th {
    border-color: var(--c-lightgrey);
    border: none !important;
}

/deep/ .fc .fc-theme-standard td,
.fc .fc-theme-standard th {
    border: none !important;
    background-color: var(--c-midgrey);
}

/deep/ .fc-theme-standard th {
    border: none !important;
}

.fc th {
    background-color: var(--c-lightgrey);
    border: none !important;
}

.fc-event {
    border-radius: 0.7em;
    padding-left: 0.5em;
}
.fc .fc-scrollgrid {
    border: none;
}

// convert arrow to circle for now indicator
.fc-direction-ltr .fc-timegrid-now-indicator-arrow {
    width: 10px;
    height: 10px;
    background-color: var(--c-error); // TODO: change to red after customisation v2 is implemented
    left: 0;
    border-radius: 50%;
    border: none;
}

.fc .fc-timegrid-now-indicator-arrow {
    position: absolute;
    z-index: 4;
    margin-top: -5px;
    background-color: var(--c-error) !important; // TODO: change to red after customisation v2 is implemented
}

.fc .fc-timegrid-now-indicator-line {
    border-top: 2px solid var(--c-error) !important; // TODO: change to red after customisation v2 is implemented
    z-index: 3;
}

.co-fc-booking-slot {
    line-height: 14px;
    font-size: 12px;
    font-style: normal;
    padding: 4px;
    .fc-event-main {
        color: var(--c-black) !important;
        cursor: pointer !important;
        font-style: normal !important;
    }
}
.fc .fc-timegrid-event .fc-event-main {
    cursor: pointer !important;
    font-style: normal !important;
}
</style>

<template>
    <b-overlay :show="loading">
        <div class="px-md-3">
            <!-- header start -->
            <div class="d-flex justify-content-between w-100 align-items-center mb-2">
                <CoHeadline :level="2" class="mb-0">{{ $t('labels.coBookingCalendar.bookingCalendar') }}</CoHeadline>
                <CoRoundButton class="d-block d-md-none" variant="icon" icon="filter" @click="viewFiltersToggle" />
            </div>

            <!-- header end -->
            <div class="row p-0 m-0 mb-5">
                <div v-show="viewFilter" class="col-12 col-lg-3 col-xl-2 p-0">
                    <!-- search and actions start -->
                    <div
                        class="d-flex align-items-center bg-white search-bar-wrapper rounded-pill mb-3 mt-lg-0 w-100"
                        v-if="searchEnabled"
                    >
                        <b-icon class="mr-2" icon="search"></b-icon>
                        <div class="search-input-wrapper">
                            <input
                                class="search-input"
                                type="search"
                                v-model="searchText"
                                :placeholder="$t('labels.search')"
                                :aria-label="$t('labels.search')"
                            />
                        </div>
                    </div>
                    <div id="locations_selector" class="mb-3 mt-5">
                        <div class="d-flex align-items-center">
                            <div
                                v-if="locationsSelectorExpanded"
                                class="coapp-icon pointer"
                                @click="toggleLocationSelector()"
                            >
                                <b-icon icon="chevron-up"></b-icon>
                            </div>
                            <div v-else class="coapp-icon pointer" @click="toggleLocationSelector()">
                                <b-icon icon="chevron-down"></b-icon>
                            </div>
                            <div class="ml-1">{{ $t('labels.location') }}</div>
                        </div>
                        <div v-if="locationsSelectorExpanded">
                            <div v-for="(item, index) in locations" :key="item.ID" class="d-flex align-items-center">
                                <CoCheckbox
                                    color="#000"
                                    @change="toggleLocation(item)"
                                    :name="item.Name"
                                    v-model="locations[index].Selected"
                                >
                                </CoCheckbox>
                            </div>
                        </div>
                    </div>

                    <div id="categories_selector" class="mb-3">
                        <div class="d-flex align-items-center">
                            <div
                                v-if="categoriesSelectorExpanded"
                                class="coapp-icon pointer"
                                @click="toggleCategorySelector()"
                            >
                                <b-icon icon="chevron-up"></b-icon>
                            </div>
                            <div v-else class="coapp-icon pointer" @click="toggleCategorySelector()">
                                <b-icon icon="chevron-down"></b-icon>
                            </div>
                            <div class="ml-1">{{ $t('labels.category') }}</div>
                        </div>
                        <div v-if="categoriesSelectorExpanded">
                            <div
                                v-for="(item, index) in categories"
                                :key="item.ID + index"
                                class="d-flex align-items-center"
                            >
                                <CoCheckbox
                                    color="#000"
                                    @change="toggleCategory(item)"
                                    :name="item.Name"
                                    v-model="categories[index].Selected"
                                >
                                </CoCheckbox>
                            </div>
                        </div>
                    </div>

                    <div id="resources_selector" class="mb-3">
                        <div class="d-flex align-items-center">
                            <div
                                v-if="resourceSelectorExpanded"
                                class="coapp-icon pointer"
                                @click="toggleResourceSelector()"
                            >
                                <b-icon icon="chevron-up"></b-icon>
                            </div>
                            <div v-else class="coapp-icon pointer" @click="toggleResourceSelector()">
                                <b-icon icon="chevron-down"></b-icon>
                            </div>
                            <div class="ml-1">{{ $t('labels.resources') }}</div>
                        </div>
                        <div v-if="resourceSelectorExpanded">
                            <div class="resources-list" style="max-height: 512px; overflow-y: auto">
                                <div class="d-flex flex-column">
                                    <div
                                        v-for="(item, index) in filteredResources"
                                        :key="item.ID + index"
                                        class="d-flex align-items-center"
                                    >
                                        <CoCheckbox
                                            :name="filteredResources[index].Name"
                                            :color="filteredResources[index].Color"
                                            v-model="filteredResources[index].Selected"
                                            @change="toggleResource(item)"
                                        >
                                        </CoCheckbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="selected_resources_selector">
                        <div class="d-flex align-items-center">
                            <div
                                v-if="selectedResourceSelectorExpanded"
                                class="coapp-icon pointer"
                                @click="toggleSelectedResourceSelector()"
                            >
                                <b-icon icon="chevron-up"></b-icon>
                            </div>
                            <div v-else class="coapp-icon pointer" @click="toggleSelectedResourceSelector()">
                                <b-icon icon="chevron-down"></b-icon>
                            </div>
                            <div class="ml-1">{{ $t('labels.selected') }}</div>
                        </div>
                        <div v-if="selectedResourceSelectorExpanded">
                            <div class="resources-list" style="max-height: 512px; overflow-y: auto">
                                <div class="d-flex flex-column">
                                    <div
                                        v-for="(item, index) in selectedResources"
                                        :key="item.ID"
                                        class="d-flex align-items-center"
                                    >
                                        <CoCheckbox
                                            :name="item.Name"
                                            :color="selectedResources[index].Color"
                                            :value="true"
                                            @change="toggleResource(item)"
                                        >
                                        </CoCheckbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <span class="text-primary pointer" @click="clearAllFilters()">{{
                            $t('labels.clearallfilters')
                        }}</span>
                    </div>

                    <!-- search and actions end -->
                </div>

                <div class="col-12 col-lg-9 col-xl-10 p-0">
                    <div class="w-100 d-flex mb-3">
                        <div class="d-flex justify-content-between w-100">
                            <div class="d-flex align-items-center">
                                <co-button-group class="mr-1">
                                    <co-button
                                        @click="prev"
                                        iconleft="chevron-left"
                                        class="px-0"
                                        variant="subtle"
                                    ></co-button>
                                    <co-button
                                        @click="next"
                                        iconleft="chevron-right"
                                        class="px-0"
                                        variant="subtle"
                                    ></co-button>
                                </co-button-group>
                                <div class="mx-1">
                                    <co-button
                                        @click="setDateToday"
                                        class="px-3"
                                        :label="$t('labels.today')"
                                        variant="subtle"
                                    />
                                </div>
                                <CoDateRangePicker
                                    v-if="selectedDate"
                                    class="flex-shrink-0 mx-1"
                                    :opens="$isMobile ? 'center' : 'right'"
                                    :singleDatePicker="true"
                                    variant="icon"
                                    @input="onContext"
                                />
                            </div>

                            <!-- change view dropdow -->
                            <CoDropdown right class="ml-1 d-block d-md-none">
                                <template v-slot:button>
                                    <CoRoundButton
                                        class="px-3"
                                        :label="$t('labels.view')"
                                        variant="subtle"
                                        icon="layout-split"
                                    />
                                </template>
                                <CoDropdownItem
                                    class="position-relative"
                                    @click="changeView('timeGridOneDay')"
                                    :title="$tc('labels.day', 1)"
                                ></CoDropdownItem>
                                <CoDropdownItem
                                    class="position-relative"
                                    @click="changeView('timeGridThreeDays')"
                                    :title="'3 ' + $tc('labels.day', 3)"
                                ></CoDropdownItem>
                                <CoDropdownItem
                                    class="position-relative"
                                    @click="changeView('listWeek')"
                                    :title="$t('labels.list')"
                                ></CoDropdownItem>
                            </CoDropdown>

                            <div class="d-none d-md-block mx-1 mt-2 mt-md-0">
                                <co-button-group class="">
                                    <co-button
                                        @click="changeView('timeGridWeek')"
                                        class="pl-3 pr-2"
                                        :label="$t('labels.week')"
                                        variant="subtle"
                                    />
                                    <co-button
                                        @click="changeView('timeGridThreeDays')"
                                        class="px-1"
                                        :label="'3 ' + $tc('labels.day', 3)"
                                        variant="subtle"
                                    />
                                    <co-button
                                        @click="changeView('timeGridOneDay')"
                                        class="px-1"
                                        :label="$tc('labels.day', 1)"
                                        variant="subtle"
                                    />
                                    <co-button
                                        @click="changeView('listWeek')"
                                        class="pl-2 pr-3"
                                        :label="$t('labels.list')"
                                        variant="subtle"
                                    />
                                </co-button-group>
                            </div>
                        </div>
                    </div>

                    <div class="calendar-container">
                        <FullCalendar
                            class="calendar round-unify"
                            :options="calendarOptions"
                            v-if="calendarOptions.initialView"
                            ref="calendar"
                        >
                            <template v-slot:eventContent="arg" class="">
                                <!-- <div class="bg-white"> -->
                                <!-- <b>{{ arg.timeText }}</b> -->
                                <b>{{ get(arg, 'event.extendedProps.originalObject.Resource.Name') }} </b>
                                <i>{{ get(arg, 'event.title') }}</i>
                                <!-- </div> -->
                            </template>
                        </FullCalendar>
                    </div>
                </div>
            </div>

            <!-- resource select modal -->
            <CoResourceSelectModal
                :moreOptions="filteredResources"
                :bestOptions="selectedResources"
                @select="selectResourceToBook"
                ref="resource-select-modal"
                :show="bookingCandidate.showResourceSelector"
            ></CoResourceSelectModal>
            <CoBookingCheckoutForAdminV2
                v-if="bookingCandidate && bookingCandidate.resource"
                :bookingCandidate="bookingCandidate"
                @created="bookingCreated"
                @hideModals="hideModals"
            ></CoBookingCheckoutForAdminV2>
            <CoBookingModal
                v-if="bookingForView"
                :booking="bookingForView"
                :asAdmin="true"
                @canceled="bookingCanceled"
                @failed="bookingCancelFailed"
                @closed="bookingModalClosed"
            />
        </div>
    </b-overlay>
</template>

<script>
import { format, startOfWeek } from 'date-fns';
import axios from 'axios';
import { get, min } from 'lodash';
import Vue from 'vue';
import FullCalendar, { CalendarApi } from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import VueMoment from 'vue-moment';
import EventBus from '@/eventBus';

import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoBookingModal from '@/components/Organisms/co-booking-modal/CoBookingModal.vue';
import CoDateRangePicker from '@/components/Atoms/co-date-range-picker/CoDateRangePicker.vue';
import CoBookingCheckoutForAdminV2 from '@/components/Organisms/co-booking-checkout-for-admin-v2/CoBookingCheckoutForAdminV2.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';

const moment = require('moment');
Vue.use(require('vue-moment'), {
    moment,
});

export default {
    components: {
        CoRoundButton,
        FullCalendar, // make the <FullCalendar> tag available
        CoBookingModal,
        CoDateRangePicker,
        CoBookingCheckoutForAdminV2,
    },
    data() {
        return {
            loading: false,

            viewCalendar: true,
            viewFilter: false,

            sort: false,
            searchText: '',
            searchEnabled: false,
            start: null,

            end: null,

            categories: [],
            selectedCategories: [],
            categoriesSelectorExpanded: true,

            locations: [],
            selectedLocations: [],
            locationsSelectorExpanded: true,

            resourceSelectorExpanded: true,
            selectedResourceSelectorExpanded: true,
            selectedResources: [],
            filteredResources: [],

            windowWidth: window.innerWidth,

            bookingCandidate: {
                showResourceSelector: false,
                start: null,
                end: null,
                resource: null,
            },

            // single booking component modal

            loadingModal: false,
            deleting: false,
            clickInfo: null,
            title: '',
            startDate: '',
            endDate: '',
            startTime: '',
            endTime: '',
            weekdayEnd: '',

            bookingComponent: {},

            selectedDate: null,

            // fullcalendar options
            calendarOptions: {
                firstDay: 1,
                selectable: true,
                businessHours: {
                    startTime: '00:00', // a start time (10am in this example)
                    endTime: '24:00',
                },
                height: '1000px',
                contentHeight: '800px',
                nowIndicator: true,
                expandRows: true,
                longPressDelay: 0,
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    listPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                navLinks: false,
                headerToolbar: null,

                initialView: '',
                eventOverlap: false,
                slotLabelFormat: { hour12: false, hour: '2-digit', minute: '2-digit' },
                views: {
                    timeGridOneDay: {
                        type: 'timeGrid',
                        duration: { days: 1 },
                        dayHeaderContent: (args) =>
                            this.$t('datetime', {
                                date: args.date,
                                customFormat: 'E P',
                            }),
                    },
                    timeGridThreeDays: {
                        type: 'timeGrid',
                        duration: { days: 3 },
                        dayHeaderContent: (args) =>
                            this.$t('datetime', {
                                date: args.date,
                                customFormat: 'E P',
                            }),
                    },
                    timeGridWeek: {
                        type: 'timeGrid',
                        duration: { days: 7 },
                        dayHeaderContent: (args) =>
                            this.$t('datetime', {
                                date: args.date,
                                customFormat: 'E P',
                            }),
                        firstDay: 1,
                    },
                },
                dayHeaderFormat: {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'numeric',
                },
                // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                // editable: true,
                // selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventColor: '#5100FF',
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                datesSet: this.handleDatesSet,
                allDaySlot: false,
                /* you can update a remote database when these fire:
            eventAdd:
            eventChange:
            eventRemove:
            */
            },
            currentEvents: [],
            slotsCancelRequests: [], // axios cancel tokens for resources slots requests
            spanCancelRequest: null, // axios cancel token for span request

            bookingForView: null,
        };
    },
    mounted() {
        this.loading = false;
        // next tick
        this.$nextTick(() => {
            this.selectedDate = moment().format('YYYY-MM-DD');
        });

        const that = this;
        window.addEventListener('resize', () => {
            that.windowWidth = window.innerWidth;
        });

        if (this.windowWidth < 400) {
            this.viewCalendar = true;
            this.calendarOptions.initialView = 'timeGridOneDay';
        } else if (this.windowWidth < 992 && this.windowWidth >= 400) {
            this.calendarOptions.initialView = 'timeGridThreeDays';
            this.viewCalendar = true;
        } else {
            this.calendarOptions.initialView = 'timeGridWeek';

            this.viewCalendar = true;
            this.viewFilter = true;
        }

        this.listLocations();
        this.getCategories();

        this.listResources();
    },
    watch: {},
    methods: {
        get,
        onContext(ctx) {
            if (!ctx || !ctx.startDate) return;
            this.selectedDate = format(ctx.startDate, 'yyyy-MM-dd');
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.gotoDate(this.selectedDate);
        },
        setDateToday() {
            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.gotoDate(moment().format('YYYY-MM-DD'));
        },
        next() {
            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.next();
        },
        prev() {
            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.prev();
        },
        changeView(view) {
            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.changeView(view);
        },
        cancelAllOngoingRequests() {
            // Cancel all existing requests and set their cancel functions to null
            for (let i = 0; i < this.slotsCancelRequests.length; i += 1) {
                if (this.slotsCancelRequests[i]) {
                    this.slotsCancelRequests[i]('Canceled due to new request');
                    this.$set(this.slotsCancelRequests, i, null);
                }
            }
            if (this.spanCancelRequest) {
                this.spanCancelRequest('Canceled due to new request');
                this.spanCancelRequest = null;
            }
        },
        selectResourceToBook(resource) {
            this.bookingCandidate.selectResourceToBook = false;
            this.bookingCandidate.resource = resource;
        },

        search() {
            this.filterResourcesList();
        },
        toggleSelectedResourceSelector() {
            this.selectedResourceSelectorExpanded = !this.selectedResourceSelectorExpanded;
        },
        toggleResource(resource) {
            this.cancelAllOngoingRequests();
            if (this.selectedResources.includes(resource)) {
                this.selectedResources = this.selectedResources.filter((r) => r.ID !== resource.ID);
            } else {
                this.selectedResources.push(resource);
            }

            this.getBookings();
        },
        toggleResourceSelector() {
            this.resourceSelectorExpanded = !this.resourceSelectorExpanded;
        },
        toggleLocationSelector() {
            this.locationsSelectorExpanded = !this.locationsSelectorExpanded;
        },

        toggleLocation(location) {
            if (this.selectedLocations.includes(location)) {
                this.selectedLocations = this.selectedLocations.filter((l) => l.ID !== location.ID);
            } else {
                this.selectedLocations.push(location);
            }
            this.filterResourcesList();
        },

        toggleCategorySelector() {
            this.categoriesSelectorExpanded = !this.categoriesSelectorExpanded;
        },

        toggleCategory(category) {
            if (this.selectedCategories.includes(category)) {
                this.selectedCategories = this.selectedCategories.filter((c) => c.ID !== category.ID);
            } else {
                this.selectedCategories.push(category);
            }

            this.filterResourcesList();
        },

        filterResourcesList() {
            const obj = {};

            if (this.searchText) {
                obj.Search = this.searchText;
            }
            obj.SpaceID = this.$store.state.space.ID;

            obj.Categories = this.selectedCategories.map((c) => c.ID);

            obj.Location = this.selectedLocations.map((l) => l.ID);

            const object = JSON.stringify(obj);

            const selectIDs = this.selectedResources.map((resource) => resource.ID);
            axios({
                method: 'POST',
                url: `/booking/resources/filter`,
                withCredentials: true,
                data: object,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.filteredResources = [];

                        this.filteredResources = response.data.map((item, index) => {
                            if (selectIDs.includes(item.ID)) {
                                item.Selected = true;
                                return item;
                            }
                            item.Selected = false;
                            return item;
                        });
                    } else {
                        this.filteredResources = [];
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        viewFiltersToggle() {
            if (this.viewFilter) {
                this.viewFilter = false;
            } else {
                this.viewFilter = true;
            }
        },

        bookingCreated() {
            const selectModal = this.$refs['resource-select-modal'];
            selectModal.hide();
            this.getBookings();

            this.next();
            this.prev();
            this.bookingCandidate = {
                selectResourceToBook: false,
                resource: null,
            };
        },

        getBookingsForResource(resource, resourceIndex) {
            // Create a new CancelToken
            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();

            // Store the cancel function for this ID
            this.$set(this.slotsCancelRequests, resourceIndex, source.cancel);

            const calendarApi = this.$refs.calendar.getApi();
            axios({
                method: 'GET',
                url: `/admin/booking/list/${resource.ID}/${this.start}/${this.end}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
                cancelToken: source.token,
            })
                .then((response) => {
                    if (response && response.data && response.data.Bookings) {
                        // map bookings to Full Calendar bookings
                        response.data.Bookings.forEach((item, index) => {
                            const event = {
                                id: item.ID,
                                title: item.Title,
                                start: new Date(item.Start * 1000),
                                end: new Date(item.End * 1000),
                                originalObject: item,
                                backgroundColor: resource.Color,
                                classNames: ['co-fc-booking-slot'],
                            };
                            calendarApi.addEvent(event);
                        });

                        this.loading = false;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    if (axios.isCancel(error)) {
                        // console.log(`Request #${resourceIndex} canceled:`, error.message);
                    } else {
                        // console.log(error);
                    }
                })
                .finally(() => {
                    // Set the cancel function to null for the completed request
                    this.$set(this.slotsCancelRequests, resourceIndex, null);
                });
        },
        listResources() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/booking/resource/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    // Keep an empty first-use response from being treated as a failed request.
                    this.filteredResources =
                        response.data && Array.isArray(response.data.Resources) ? response.data.Resources : [];
                    this.filteredResources.sort((a, b) => a.Name.localeCompare(b.Name));
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        listLocations() {
            this.$store
                .dispatch('listLocations')
                .then((locations) => {
                    this.locations = locations.map((item, index) => {
                        item.Selected = false;
                        return item;
                    });
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        getCategories() {
            axios({
                method: 'GET',
                url: '/admin/booking/category/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response.data && response.data.Categories) {
                        const categories = response.data.Categories;

                        this.categories = categories.map((item, index) => {
                            item.Selected = false;
                            return item;
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getBookings() {
            // get calendar api
            const calendarApi = this.$refs.calendar.getApi();
            // get current view
            const { view } = calendarApi;
            // get start and end dates
            this.start = view.activeStart.getTime() / 1000;
            this.end = view.activeEnd.getTime() / 1000;

            this.cancelAllOngoingRequests();
            // clear calendar
            calendarApi.removeAllEvents();

            // get bookings for each resource
            this.selectedResources.forEach((resource, index) => {
                this.getBookingsForResource(resource, index);
            });
        },
        handleDatesSet(event) {
            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.removeAllEvents();
            const error = calendarApi.removeAllEvents();
            if (error) {
                console.log(error);
            }
            const startUTC = new Date(
                event.start.getUTCFullYear(),
                event.start.getUTCMonth(),
                event.start.getUTCDate(),
                event.start.getUTCHours(),
                event.start.getUTCMinutes(),
                event.start.getUTCSeconds()
            );
            const endUTC = new Date(
                event.end.getUTCFullYear(),
                event.end.getUTCMonth(),
                event.end.getUTCDate(),
                event.end.getUTCHours(),
                event.end.getUTCMinutes(),
                event.end.getUTCSeconds()
            );
            const start = Math.floor(startUTC.getTime() / 1000);
            const end = Math.floor(endUTC.getTime() / 1000);
            this.start = start;
            this.end = end;

            if (this.selectedResources.length === 0) {
                this.listBookingsInSpan(start, end);
            } else {
                this.loading = true;
                this.cancelAllOngoingRequests();
                const calendarApi = this.$refs.calendar.getApi();
                calendarApi.removeAllEvents();
                const that = this;
                this.selectedResources.forEach((item, index) => {
                    that.getBookingsForResource(item, index);
                });
            }
            // always start week view on monday
            const dateInfo = event;
            if (dateInfo && dateInfo.view && dateInfo.view.type === 'timeGridWeek' && dateInfo.start) {
                const monday = startOfWeek(dateInfo.start, { weekStartsOn: 1 });
                if (dateInfo.start.getDay() !== 1) {
                    const { calendar } = this.$refs;
                    if (calendar) {
                        calendar.getApi().gotoDate(monday);
                    }
                }
            }
        },

        listBookingsInSpan(start, end) {
            this.loading = true;

            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            const error = calendarApi.removeAllEvents();
            if (error) {
                console.log(error);
            }

            if (this.spanCancelRequest) {
                this.spanCancelRequest('Canceled due to new request');
            }

            // Create a new CancelToken
            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();

            // Store the cancel function for this ID
            this.spanCancelRequest = source.cancel;

            axios({
                method: 'GET',
                url: `/admin/booking/list?start=${start}&end=${end}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
                cancelToken: source.token,
            })
                .then((response) => {
                    if (response && response.data && response.data.Bookings) {
                        // map bookings to Full Calendar bookings
                        response.data.Bookings.forEach((item, index) => {
                            const event = {
                                id: item.ID,
                                title: item.Title,
                                start: new Date(item.Start * 1000),
                                end: new Date(item.End * 1000),
                                originalObject: item,
                                classNames: ['co-fc-booking-slot'],
                            };

                            if (item.Resource && item.Resource.Color) {
                                event.backgroundColor = item.Resource.Color;
                                event.borderColor = item.Resource.Color;
                            } else {
                                event.backgroundColor = '#5100FF';
                                event.borderColor = '#5100FF';
                            }

                            calendarApi.addEvent(event);
                        });
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    if (axios.isCancel(error)) {
                        // console.log('Request canceled', error.message);
                    } else {
                        // console.log(error);
                    }
                })
                .finally(() => {
                    // Set the cancel function to null for the completed request
                    this.spanCancelRequest = null;
                });
        },

        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
        },
        hideModals() {
            const selectModal = this.$refs['resource-select-modal'];
            selectModal.hide();
        },
        addBooking() {
            const today = new Date();
            today.setHours(today.getHours() + Math.round(today.getMinutes() / 60));
            today.setMinutes(0, 0, 0);

            const selectModal = this.$refs['resource-select-modal'];
            selectModal.show();

            const todayPlusHour = new Date(JSON.parse(JSON.stringify(today)));

            todayPlusHour.setTime(todayPlusHour.getTime() + 1 * 60 * 60 * 1000);

            this.bookingCandidate.start = today;
            this.bookingCandidate.end = todayPlusHour;
        },
        handleDateSelect(selectInfo) {
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.unselect(); // clear date selection
            const selectModal = this.$refs['resource-select-modal'];
            selectModal.show();
            this.bookingCandidate.start = selectInfo.start;
            this.bookingCandidate.end = selectInfo.end;
            this.bookingCandidate.resource = null;
            this.bookingCandidate.allDay = selectInfo.allDay;
        },

        handleEvents(events) {
            this.currentEvents = events;
        },
        cancelSelection() {
            this.sort = false;

            this.bookingResources.forEach((item) => {
                item.Selected = false;
            });
        },
        clearAllFilters() {
            if (this.windowWidth < 992) {
                this.viewFilter = false;
            }
            this.loading = true;
            const that = this;
            this.selectedLocations = [];
            this.selectedCategories = [];
            this.selectedResources = [];
            this.locations = [];
            this.categories = [];

            this.listLocations();
            this.getCategories();

            this.listResources();

            this.cancelAllOngoingRequests();
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.removeAllEvents();

            this.listBookingsInSpan(this.start, this.end);
        },

        bookingModalClosed() {
            this.bookingForView = null;
            this.clickInfo = null;
        },
        bookingCancelFailed(error) {
            console.log(error);
            EventBus.$emit('ERROR', {
                Message: this.$t('errors.failedGeneric'),
                Details: get(error, 'response.data', ''),
            });
        },
        bookingCanceled() {
            this.clickInfo.event.remove();
            this.bookingForView = null;
            this.clickInfo = null;
            EventBus.$emit('INFO', {
                Message: this.$t('messages.booking.cancelSuccess'),
            });
        },
        handleEventClick(clickInfo) {
            this.clickInfo = clickInfo;
            this.bookingForView = clickInfo.event.extendedProps.originalObject;
        },
    },
};
</script>
